import React from 'react';
import { observer } from 'mobx-react';

import { i18n } from 'core/localization';
import { Section } from 'controls/react/layout/section';
import { FormEntryNew } from 'controls/react/form/formEntryNew';
import { AntSelect } from 'controls/react/ant/ant-select/antSelect';
import { AntTextArea } from 'controls/react/ant/antInput';
import { LogEntryStatus } from '../../types';
import { LogEntryFormStore } from './logEntryFormStore';

const logEntryStatuses = (): { value: LogEntryStatus; label: string }[] => [
	{ value: LogEntryStatus.Ok, label: i18n('OK') },
	{ value: LogEntryStatus.Error, label: i18n('Error') },
	{ value: LogEntryStatus.Warning, label: i18n('Warning') },
	{ value: LogEntryStatus.Failed, label: i18n('Failed') },
	{ value: LogEntryStatus.Unknown, label: i18n('Unknown') },
];

type LogEntryFormProps = {
	store: LogEntryFormStore;
};

export const LogEntryForm = observer((props: LogEntryFormProps) => {
	const { store } = props;
	const { model } = store;

	return (
		<Section appearance={'none'} contentPadding={true} childrenPadding={true}>
			<FormEntryNew label={i18n('Status')} model={model} modelField={'status'}>
				<AntSelect options={logEntryStatuses()} />
			</FormEntryNew>
			<FormEntryNew
				label={i18n('Message')}
				model={model}
				modelField={'message'}
				validator={store.validator}
				placeholder={i18n('Enter the log entry message here...')}
				hasPlaceholder={true}
			>
				<AntTextArea height={250} />
			</FormEntryNew>
		</Section>
	);
});
